import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import { linkToString } from '@/helper/urls';
import type { GlobalFooterStoryblok } from '@/types/component-types-sb';
import { ColumnWidth } from '@/types/layoutTypes';
import Link from 'next/link';

import classes from './TopSection.module.scss';

const TopSection: React.FC<{ blok: GlobalFooterStoryblok }> = ({ blok }) => {
  return (
    <div className={classes.TopSection}>
      <div className={classes.heading}>Stadtwerke Düsseldorf</div>
      <div className={classes.socials}>
        {blok.social_icons.map((socialIcon) => (
          <Link
            target="_blank"
            rel="noreferrer"
            key={`social-link-${socialIcon._uid}`}
            href={linkToString(socialIcon.link)}
            aria-label={socialIcon.title}
          >
            <StoryblokImage
              image={socialIcon.icon}
              width={{
                columnsMobile: ColumnWidth.ONE_SIXTH,
                columnsTablet: ColumnWidth.ONE_SIXTH,
                columnsDesktop: ColumnWidth.ONE_SIXTH,
              }}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TopSection;
